// components/Container.jsx


const Container = ({
  children,
  className = '',
  maxWidth = 'clamp(320px, 92vw, 1600px)', // scales smoothly, no hard center-block on big screens
  as: Tag = 'div',
}) => {
  return (
    <Tag
      className={`w-full mx-auto ${className}`}
      style={{
        maxWidth,
        width: '100%',
        // fluid padding: tiny on mobile, grows smoothly on large screens
        paddingLeft: 'clamp(1rem, 1rem + 1.5vw, 4rem)',
        paddingRight: 'clamp(1rem, 1rem + 1.5vw, 4rem)',
      }}
    >
      {children}
    </Tag>
  );
};

export default Container;